import api from "./axios";

export const login = async (email: string, password: string) => {
  const res = await api.post("/login", { email, password });
  return res.data; // Spodziewaj się access_token, user
};

export const register = async (email: string, password: string) => {
  const res = await api.post("/register", { email, password });
  return res.data;
};
